import loadable from '@loadable/component';

export const LazyGuest = loadable(() => import(/* webpackChunkName: "content/guest" */ './Guest'));
